/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 设置支付密码（开通电子钱包）
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  password: member.UserLoginPasswordDTO,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/password`,
    data: password,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
